import useDocument, { DocumentConfig } from './useDocument';
import { Bill, BillStatus } from '../models/bill';

const config: DocumentConfig = {
  listKey: 'bills',
  detailKey: 'bill',
  basePath: 'bills',
  archivePath: (id) => `bills/${id}/archive`,
  voidPath: (id) => `bills/${id}/void`,
  voidType: 'Bill', // EPIC_VOID_FLOW_2026-10
  statusPath: (id) => `bills/${id}/setStatus`,
  statusAsJson: true,
};

const useBill = (props: { id?: string }) => useDocument<BillStatus, Bill>(config, props);

export default useBill;
